var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 965.3 965.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #055ba2;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #055ba2;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-miterlimit: 10;\n        stroke-width: 80px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 482.65,
    cy: 482.65,
    r: 442.65,
    transform: "translate(-199.92 482.65) rotate(-45)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 482.65,
    cy: 248.17,
    r: 69.93,
    transform: "translate(-34.12 413.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M598.52,773.83h-231.73c33.21,0,60.12-26.92,60.12-60.12v-290.05c0-12.45-10.1-22.55-22.55-22.55h-37.57,171.61v312.6c0,33.21,26.92,60.12,60.12,60.12h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/Icon_Info.4005e2afbbbce7aaf9da13abdbabad7f.svg";
export { ForwardRef as ReactComponent };